module.exports = __webpack_public_path__ + "static/forte_logo-d64475fddfa95770f4a34015889a442d.png";